export default __webpack_public_path__ + "static/media/Climate Change.b947d7d1.pdf";